/**
 * Minimalerei — Product-Card Swatch-Hover-Swap
 *
 * Hovern über einen Farb-Swatch auf der Produktkarte → primary-Image
 * wechselt temporär zum featured_media der entsprechenden Variante.
 * Mouse-out → Original-Bild zurück.
 *
 * Während des Swatch-Hovers wird die Klasse .is-swatch-hover auf der
 * Card gesetzt — CSS unterdrückt damit den Standard-Hover-Cross-Fade
 * (mp-card__image--hover) damit das Variant-Bild nicht überlagert wird.
 */

(function () {
  'use strict';

  function initCard(card) {
    var primaryImg = card.querySelector('.mp-card__image--primary img');
    if (!primaryImg) return;

    var swatches = card.querySelectorAll('.mp-card__swatch[data-variant-image]');
    if (!swatches.length) return;

    // Original-src/srcset zum Restore beim Mouse-out cachen.
    var originalSrc = primaryImg.getAttribute('src') || '';
    var originalSrcset = primaryImg.getAttribute('srcset') || '';

    swatches.forEach(function (swatch) {
      var variantImg = swatch.getAttribute('data-variant-image');
      var variantSrcset = swatch.getAttribute('data-variant-srcset') || '';
      if (!variantImg) return;

      swatch.addEventListener('mouseenter', function () {
        primaryImg.setAttribute('src', variantImg);
        if (variantSrcset) {
          primaryImg.setAttribute('srcset', variantSrcset);
        } else {
          primaryImg.removeAttribute('srcset');
        }
        card.classList.add('is-swatch-hover');
      });

      swatch.addEventListener('mouseleave', function () {
        primaryImg.setAttribute('src', originalSrc);
        if (originalSrcset) {
          primaryImg.setAttribute('srcset', originalSrcset);
        } else {
          primaryImg.removeAttribute('srcset');
        }
        card.classList.remove('is-swatch-hover');
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.mp-card').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
